import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconLockOutlined = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M8 12V8.34c0-4.18 3.06-7.9 7.22-8.3A7.986 7.986 0 0 1 24 8v4h2c1.1 0 2 .9 2 2v16c0 1.1-.9 2-2 2H5.64C4.74 32 4 31.26 4 30.36V13.64c0-.9.74-1.64 1.64-1.64zm2 0h12V8c0-3.32-2.68-6-6-6s-6 2.68-6 6zm16 18H6V14h20z" clipRule="evenodd" /><path fill="currentColor" d="M16 26c-.56 0-1-.44-1-1v-4c0-.56.44-1 1-1s1 .44 1 1v4c0 .56-.44 1-1 1" /></svg>;
export default SvgIconLockOutlined;